function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityNursingRoomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4v24h24V4zM4 2a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.454 17.975l7.071-7.071 1.414 1.414-6.992 6.993 4.243 4.242 6.992-6.992 1.414 1.414-7.07 7.07a2 2 0 01-2.83 0l-4.242-4.242a2 2 0 010-2.828z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.94 9.49l7.07 7.07a1 1 0 01-1.414 1.415l-7.07-7.071a1 1 0 011.413-1.414z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303 17.268a5 5 0 00-7.07-7.071l1.413 1.414a3 3 0 014.243 4.242l1.414 1.415z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89 8.782a2 2 0 112.828 2.829l-1.415 1.414-2.828-2.828 1.414-1.415zM13.818 13.025l3.536 3.536-1.415 1.414-3.535-3.536 1.414-1.414zM10.99 15.854l2.828 2.828-1.414 1.414-2.829-2.828 1.415-1.414z",
    fill: props.color
  }));
}

export default SvgIconFacilityNursingRoomFilled;